//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class AttendanceNoteTemplateDisplayItem extends ItemBase {
    Description: string | null = null;
    Editable: boolean = false;
    ID: string | null = null;
    Name: string | null = null;
    Body: string | null = null;
    TeacherID: string | null = null;

    constructor(initializer?: Partial<AttendanceNoteTemplateDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceNoteTemplateDisplayItem";
}
